import type { ITransportResponse } from '@cubejs-client/core'
import { HttpTransport } from '@cubejs-client/core'

const MAX_ENTRIES = 100
const responseSizes = new Map<string, number>()

const queryKey = (params: Record<string, unknown>): string => {
  const query = params.query ?? params
  return JSON.stringify(query)
}

export const buildQueryKey = queryKey

export const consumeResponseSize = (key: string): number | null => {
  const size = responseSizes.get(key) ?? null
  responseSizes.delete(key)
  return size
}

export class InstrumentedHttpTransport extends HttpTransport {
  request(
    method: string,
    params: Record<string, unknown>,
  ): ITransportResponse<Response> {
    const original = super.request(method, params)
    const key = queryKey(params)

    return {
      subscribe: cb => {
        return original.subscribe((response, resubscribe) => {
          if (response instanceof Response) {
            const contentLength = response.headers.get('content-length')
            if (contentLength) {
              const size = Number.parseInt(contentLength, 10)
              if (!Number.isFinite(size) || size < 0)
                return cb(response, resubscribe)
              responseSizes.set(key, size)
              if (responseSizes.size > MAX_ENTRIES) {
                const oldest = responseSizes.keys().next().value
                if (oldest) responseSizes.delete(oldest)
              }
            }
          }
          return cb(response, resubscribe)
        })
      },
    }
  }
}
